import React from 'react'
import { priceunit } from '../../Components/client-config'
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDonationFromCart } from '../../Redux/actions/cart';
import { useTranslation } from 'react-i18next';
import { calcTotalGstTax } from '../../utils/helpers';

export default function OrderDetail(props: any) {
    const cartData = useSelector((state: any) => state.cart.cartData);
    const cartQty = useSelector((state: any) => state.cart.cartQty);
    const storeSelected = useSelector((state: any) => state.store.storeSelected);
    const paymentMethod = useSelector((state: any) => state.payment.paymentMethod);
    const taxDataCash = useSelector((state: any) => state.store.taxDataCash);
    const taxDataCard = useSelector((state: any) => state.store.taxDataCard);
    const donationItems = useSelector((state: any) => state.cart.donationItems);
    const donationData = useSelector((state: any) => state.cart.donationData);
    const isReverseCard = useSelector((state: any) => state.payment.payment_tax);
    const dispatch:any = useDispatch();
    const { t } = useTranslation();
    const calcTotal = (data: any) => {
        let sum: any = 0;
        data.forEach((item: any) => {
            sum += (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) ? item.updateOnlineItemPrice : parseInt(item.totalItemPrice);
        });
        if (props.orderType == "Delivery") {
            if (!_.isEmpty(props.storeSelected)) {
                sum = props.pos_fee > 0 ? sum + (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee) + parseInt(props.pos_fee) : sum + (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee);
            }
            else {
                sum = props.pos_fee > 0 ? sum + parseInt(props.pos_fee) : sum;
            }
        } else if (props.orderType == "Pickup") {
            sum = props.pos_fee > 0 ? sum + parseInt(props.pos_fee) : sum;
        }
        if(donationItems?.length > 0) {
            donationItems.map((item: any) => {
                sum += parseInt(item.totalItemPrice);
            })
        }
        let finalSum = sum;
        return Math.round(finalSum);
    };
    const calcItemTotal = (carts: any) => {
        let sum = 0;
        carts.forEach((item: any) => {
            sum += (item.updateOnlineItemPrice && item.updateOnlineItemPrice > 0) ? item.updateOnlineItemPrice : parseInt(item.totalItemPrice);
        });
        return sum;
    };
    const showQuantity = (donation_id: number, quantity: number) => {
        let showBracketQuantity = true;
        if(donationData?.length > 0) {
            const item: any = donationData.find((item: any) => item.donation_id === donation_id);
            if (item) {
                if(item.amount == 0 || item.quantity_controls == 0 || quantity == 1) {
                    showBracketQuantity = false;
                }
            }
        }
        return showBracketQuantity
    }
    return (
        <div>
            <div className='instructions-box '>
                <div className='bucket-img'>
                    <h5>{t("YOUR_ORDER")}</h5>
                </div>
                <div className='price-info'>
                    <h6>{t("SUB_TOTAL")} :</h6>
                    <h5>{storeSelected ? priceunit + calcItemTotal(cartData) : priceunit + 0}</h5>
                </div>
                {props.orderType == "Delivery" &&
                    <div className='price-info'>
                        <h6>{t("DELIVERY_FEE")} :</h6>
                        <h5>{storeSelected ? cartQty > 0 ? priceunit + (props.onlineDeliveryfee > 0 ? props.onlineDeliveryfee : props.deliveryfee) : priceunit + 0 : priceunit + 0}</h5>
                    </div>
                }
                {props.pos_fee > 0 &&
                    <div className='price-info'>
                        <h6>{t("POS_FEE")} :</h6>
                        <h5>{storeSelected ? priceunit + props.pos_fee : priceunit + 0}</h5>
                    </div>
                }
                {
                    taxDataCash.tax_percent > 0 || taxDataCard.tax_percent > 0 ?
                    <div className='price-info'>
                        <h6>{t("GST")} {paymentMethod && paymentMethod !== 'Cash' ? `( ${Math.round(taxDataCard.tax_percent)} % )` : `( ${Math.round(taxDataCash.tax_percent)} % )`}:</h6>
                        <h5>{priceunit} {calcTotalGstTax(cartData, paymentMethod, isReverseCard, taxDataCash, taxDataCard, props.orderType, props.deliveryfee, "orderDetail")}</h5>
                    </div>
                    :
                    null
                }
                {
                    donationItems?.length > 0 ?
                        donationItems.map((item: any) => {
                            return (
                                <div className='price-info' key={item.donation_id}>
                                    <h6>
                                    {t("DONATION")} 
                                        {
                                            showQuantity(item.donation_id, item.quantity) ?
                                                ` (Rs. ${item.price}${item.quantity > 1 ? " x " + item.quantity + "" : ""})`
                                            :
                                            null
                                        }
                                        {":"}
                                    </h6>
                                    <div className='d-flex align-items-center'>
                                        <i 
                                            className="ri-delete-bin-line donation-bin" 
                                            onClick={() => dispatch(deleteDonationFromCart(item.donation_id))}
                                        >
                                        </i>
                                        <h5 className='w-100'>{priceunit} {item.totalItemPrice}</h5>
                                    </div>
                                </div>
                            )
                        })
                    :
                    null
                }
                <div className='price-info border-top pt-2'>
                    <h6>{t("TOTAL")} :</h6>
                    <h5>{storeSelected ? cartQty > 0 ? priceunit + calcTotal(cartData) : priceunit + 0 : priceunit + 0}</h5>
                </div>
            </div>
        </div>
    )
}
